import Vue from 'vue';
import { vuexSimple, loadForage, setDefaults } from '@/helpers';
import media from '@/store/media';
export default insights();
async function insights() {
  const props = {
    // tags: null,
    q: '',
    andOr: 'and',
    facetsCollapsed: true,
    collapse: false,
    tags: {},
    selectedTags: {},
    selectedTagsForGrid: {},
    sectors: [],
    selectedSectors: [],
    types: [],
    selectedTypes: [],
    categories: [],
    selectedCategories: [],
    sourceIds: [],
    selectedSourceIds: {},
    hasFactoids: false,
    hasDirectives: false,
    loadedInsights: null,
    selectedInsights: {},
    // duration: [0, 50],
    age: [0, 5],
    sentiment: [0, 5],
    interestingness: [0, 5],
    visuality: [0, 5],
    volume: [0, 5],
    sourcePopularity: [0, 5],
    // default_duration: null,
    default_age: null,
    default_sentiment: null,
    default_interestingness: null,
    default_visuality: null,
    default_volume: null,
    default_sourcePopularity: null
  };
  // console.log('insightsNS before');
  setDefaults(props);
  await loadForage(props, 'insightsNS/');
  // console.log('insightsNS after');
  return vuexSimple(
    {
      ...media,
      mutations: {
        ...media.mutations,
        deleteInsight({ loadedInsights }, value) {
          Vue.delete(loadedInsights, value);
          // console.log('deleteInsight', value);
        },
        deleteInsightPage({ loadedInsights }, value) {
          Object.keys(loadedInsights).forEach(insight => {
            const [start] = insight.split('|');
            if (value === start) {
              Vue.delete(loadedInsights, insight);
              // console.log('deleteInsight', value, insight);
            }
          });
        },
        deleteInsightDocument({ loadedInsights }, value) {
          Object.keys(loadedInsights).forEach(insight => {
            const [start] = insight.split('|');
            if (value === start.replace(/\-\d+$/, '')) {
              Vue.delete(loadedInsights, insight);
              // console.log('deleteInsight', value, insight);
            }
          });
        },
        toggleTag({ selectedTags }, value) {
          if (selectedTags[value]) {
            Vue.delete(selectedTags, value);
          } else {
            Vue.set(selectedTags, value, true);
          }
        },
        selectInsight({ selectedInsights }, value) {
          const force = value.key;
          const key = (force && value.key) || value;
          const selected = force ? value.select : !selectedInsights[value];
          console.log('selectInsight selected', selected, key);
          if (selected) {
            Vue.set(selectedInsights, key, true);
            console.log('selectedInsights was true', selectedInsights);
          } else {
            Vue.delete(selectedInsights, key);
          }
        }
      },
      actions: {
        ...media.actions,
        deleteInsight({ commit }, value) {
          console.log('deleteInsight', value);
          commit('deleteInsight', value);
        },
        deleteInsightPage({ commit }, value) {
          commit('deleteInsightPage', value);
        },
        deleteInsightDocument({ commit }, value) {
          commit('deleteInsightDocument', value);
        },
        async fetchMedia(/*{ dispatch }*/) {
          // return await dispatch('fetchMedia', 'document', { root: true });
        },
        async toggleTag(
          {
            commit,
            getters: { selectedTags }
          },
          value
        ) {
          commit('toggleTag', value);
          Vue.$localforage.setItem('insightsNS/selectedTags', selectedTags);
        },
        selectInsight({ commit }, value) {
          commit('selectInsight', value);
        },
        async loadedInsights({ commit }, value) {
          commit('loadedInsights', value.reduce((all, key) => {
            all[key] = true;
            return all;
          }, {}));
        }
      },
      getters: {
        ...media.getters,
        allTags(
          moduleState,
          { sentimentQuantiles, volumeQuantiles, selectedTags },
          state,
          { filteredDocsWithInsights }
        ) {
          return filteredDocsWithInsights?.reduce((all, { kti }) => {
            kti.forEach(({ tg, sq, vq }) => {
              if (sentimentQuantiles.includes(sq) && volumeQuantiles.includes(vq) && hasSelectedTags(tg)) {
                tg.forEach(tag => {
                  all[tag] = all[tag] || 0;
                  all[tag]++;
                });
              }
            });
            return all;
          }, {});
          function hasSelectedTags(tags) {
            const entries = Object.entries(selectedTags);
            return (
              entries.length ===
              entries.reduce((matches, [tag]) => {
                if (tags.includes(tag)) {
                  matches++;
                }
                return matches;
              }, 0)
            );
          }
        },
        allTagsFiltered(state, { allTags }) {
          let r = aggregate();
          if (Object.keys(r).length < 20) {
            r = aggregate(0);
          }
          return r;
          function aggregate(thresold = 5) {
            return Object.entries(allTags || {}).reduce((all, [tag, count]) => {
              if (count > thresold) {
                all[tag] = (count < 40 && count) || 40;
              }
              return all;
            }, {});
          }
        },
        tagsForGrid(
          state,
          { sentimentQuantiles, volumeQuantiles, selectedTags },
          rootState,
          { filteredDocsWithInsights }
        ) {
          //const tags = {};
          const tags = filteredDocsWithInsights?.reduce((all, { kti }) => {
            kti?.forEach(({ tg, sq, vq }) => {
              const test = hasSelectedTags(tg);
              //console.log(JSON.stringify({ test }));
              tg?.forEach(tag => {
                all[tag] = all[tag] || 0;
                //console.log('tagCheck', sentimentQuantiles.includes(sq) && volumeQuantiles.includes(vq));
                if (sentimentQuantiles.includes(sq) && volumeQuantiles.includes(vq) && test) {
                  all[tag]++;
                }
              });
            });
            return all;
          }, {});
          return ((tags && Object.entries(tags)) || []).sort((a, b) => b[1] - a[1]);
          function hasSelectedTags(tags) {
            const entries = Object.entries(selectedTags);
            return (
              entries.length ===
              entries.reduce((matches, [tag]) => {
                if (tags.includes(tag)) {
                  matches++;
                }
                return matches;
              }, 0)
            );
          }
          // return ((allTags && Object.entries(allTags)) || []).sort((a, b) => b[1] - a[1]);
        },
        docsWithFilteredKTIs(
          state,
          { sentimentQuantiles, volumeQuantiles, selectedTags, andOr, hasFactoids, hasDirectives },
          rootState,
          { filteredDocsWithInsights, selectedAllTags, inheritUpper }
        ) {
          return filteredDocsWithInsights?.reduce((all, doc) => {
            const { kti } = doc;
            const copy = { ...doc };
            copy.kti = [];
            kti.forEach(kt => {
              const { tg, sq, vq, hf, hd } = kt;
              if (hasSelectedTags(tg, andOr) && sentimentQuantiles.includes(sq) && volumeQuantiles.includes(vq)) {
                if ((!hasFactoids || hf) && (!hasDirectives || hd)) {
                  copy.kti.push(kt);
                }
              }
            });
            if (copy.kti.length) {
              all.push(copy);
            }
            return all;
          }, []);
          function hasSelectedTags(tags) {
            let r = false;
            if (andOr === 'and') {
              //Object.keys(selectedTags).every(tag => r = r.filter(({ tags }) => tags[tag]));
              r = Object.keys(selectedTags).every(tag => tags.includes(tag));
            } else if (andOr === 'or') {
              const keys = Object.keys(selectedTags);
              r = !keys.length || Object.keys(selectedTags).some(tag => tags.includes(tag));
              // r = r.filter(({ tg }) => tg.some(t => selectedTags[t]));
            } else {
              r = Object.keys(selectedTags).every(tag => !tags.includes(tag));
              //Object.keys(selectedTags).forEach(tag => r = r.filter(({ tags }) => !tags[tag]));
            }
            return r;
            // const entries = Object.entries(selectedTags);
            // return (
            //   entries.length ===
            //   entries.reduce((matches, [tag]) => {
            //     if (tags.includes(tag)) {
            //       matches++;
            //     }
            //     return matches;
            //   }, 0)
            // );
          }
        },
        insightsForCheatSheet(state, { loadedInsights, selectedInsights }) {
          return Object.keys(loadedInsights || selectedInsights);
        },
        cheatsheet(state, { insightsForCheatSheet: insights }) {
          const documents = insights.reduce((docs, insight) => {
            const i = readInsightKey(insight);
            const { did, pgn, imgu } = i;
            const a = (docs[did] = docs[did] || { did });
            const ai = (a.insights = a.insights || []);
            ai.push(insight);
            return docs;
          }, {});
          return { documents, insights };
        },
        hasCheatsheet(state, { cheatsheet }) {
          return !!Object.keys(cheatsheet?.documents || {}).length;
        },
        insightsFromCheatSheet(
          state,
          {
            cheatsheet: { insights }
          }
        ) {
          return insights.map(readInsightKey);
        }
      }
    },
    props
  );
}
function readInsightKey(key) {
  let did;
  let pgn;
  let w;
  let k;
  key.replace(/^([^\|]+?)\-(\d+)\|([\d\.]+)\|(.+)/, (match, p1, p2, p3, p4) => {
    did = p1;
    pgn = p2;
    w = p3;
    try {
      k = atob(p4);
    } catch (ex) {}
  });
  /*return JSON.stringify({
    did,
    pgn,
    w,
    k,
    imgu: `https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-${ pgn }.png`
  });*/
  return { did, pgn, w, k, imgu: `https://d23xtmsrsmj88h.cloudfront.net/picture-images/${ did }-${ pgn }.png` };
}
